(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["delivery-steps"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setExpanded(section, expanded) {
      var list = section.querySelector('.delivery-steps__list');
      var btn = section.querySelector('.delivery-steps__toggle');
      if (!list || !btn) return;
      list.setAttribute('data-collapsed', expanded ? 'false' : 'true');
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      var text = btn.querySelector('.delivery-steps__toggle-text');
      if (text) text.textContent = expanded ? btn.dataset.labelLess : btn.dataset.labelMore;
    }

    document.addEventListener('click', function (event) {
      var btn = event.target.closest('.delivery-steps__toggle');
      if (!btn) return;
      var section = btn.closest('.delivery-steps');
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      setExpanded(section, !expanded);
      if (expanded) {
        var list = section.querySelector('.delivery-steps__list');
        if (list && list.getBoundingClientRect().top < 0) {
          list.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });

    // Theme editor: open the list when a hidden step is selected
    document.addEventListener('shopify:block:select', function (event) {
      var step = event.target.closest && event.target.closest('.delivery-steps__step--extra');
      if (step) setExpanded(step.closest('.delivery-steps'), true);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
